import React, { Component } from 'react'
import Header from '../Components/header/index.jsx'
import Footer from '../Components/Footer/index'
import './index.scss'
import { ArrowRightOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'

class index extends Component {
  componentWillMount() {
    document.title = '高温温湿度_温湿度_智慧物联网_大数据平台_数字孪生_北京锐控自动化科技有限公司|新闻中心'
  }
  render() {
    return (
      <div style={{ background: '#f6f6f6' }}>
        <Header></Header>
        <div className="pressCenter-Content">
          <div className="pressCenter-Content-title">
            <div className="pressCenter-Content-title-h1">新闻中心</div>
            <div className="pressCenter-Content-title-text">NEWS CENTER</div>
          </div>
        </div>
        <div style={{ height: '2.857143rem' }}></div>
        <div className="pressCenter-details">
          <Link to="/news/1.html">
            <div className="pressCenter-details-item" style={{ marginRight: '.6rem' }}>
              <div className="pressCenter-details-item-imgbox">
                <div className="pressCenter-details-item-imgbox-new">NEW</div>
              </div>
              <div className="pressCenter-details-item-title">喜讯！锐控高端光电编码器芯片成功实现量产</div>
              <div className="pressCenter-details-item-time">2023-03-18</div>
              <div className="pressCenter-details-item-text">光电传感器在生活中随处可见，然而其核心部分光电芯片一直是我国被卡脖子的“痛点”高科技产业。光电编码器芯片就是其中之一。在各类电机控制系统中，光电编码器对控制系统的性能起决定性作用。编码器将信号或数据进行编制，转换为可用于通讯、传输和存储的信号形式，对电机的定位精度、速度稳定性、功率损耗和安全性都有重要影响。如今，传周半导体打破高端光电编码器芯片多年的外国垄断局面，成功实现量产。</div>
              <div className="pressCenter-details-item-button">
                查看详情
                <ArrowRightOutlined style={{ fontSize: '.6rem', marginLeft: '.285714rem ' }} />
              </div>
            </div>
          </Link>
          <Link to="/news/1.html">
            <div className="pressCenter-details-item">
              {/* <div className="pressCenter-details-item-imgbox">
                <div className="pressCenter-details-item-imgbox-new">NEW</div>
              </div> */}
              <div className="pressCenter-details-item-title">喜讯！锐控高端光电编码器芯片成功实现量产</div>
              <div className="pressCenter-details-item-time">2023-03-18</div>
              <div className="pressCenter-details-item-text">光电传感器在生活中随处可见，然而其核心部分光电芯片一直是我国被卡脖子的“痛点”高科技产业。光电编码器芯片就是其中之一。在各类电机控制系统中，光电编码器对控制系统的性能起决定性作用。编码器将信号或数据进行编制，转换为可用于通讯、传输和存储的信号形式，对电机的定位精度、速度稳定性、功率损耗和安全性都有重要影响。如今，传周半导体打破高端光电编码器芯片多年的外国垄断局面，成功实现量产。</div>
              <div className="pressCenter-details-item-button">
                查看详情
                <ArrowRightOutlined style={{ fontSize: '.6rem', marginLeft: '.285714rem ' }} />
              </div>
            </div>
          </Link>
          <Link to="/news/1.html">
            <div className="pressCenter-details-item" style={{ marginRight: '.6rem' }}>
              {/* <div className="pressCenter-details-item-imgbox">
                <div className="pressCenter-details-item-imgbox-new">NEW</div>
              </div> */}
              <div className="pressCenter-details-item-title">喜讯！锐控高端光电编码器芯片成功实现量产</div>
              <div className="pressCenter-details-item-time">2023-03-18</div>
              <div className="pressCenter-details-item-text">光电传感器在生活中随处可见，然而其核心部分光电芯片一直是我国被卡脖子的“痛点”高科技产业。光电编码器芯片就是其中之一。在各类电机控制系统中，光电编码器对控制系统的性能起决定性作用。编码器将信号或数据进行编制，转换为可用于通讯、传输和存储的信号形式，对电机的定位精度、速度稳定性、功率损耗和安全性都有重要影响。如今，传周半导体打破高端光电编码器芯片多年的外国垄断局面，成功实现量产。</div>
              <div className="pressCenter-details-item-button">
                查看详情
                <ArrowRightOutlined style={{ fontSize: '.6rem', marginLeft: '.285714rem ' }} />
              </div>
            </div>
          </Link>
          <Link to="/news/1.html">
            {' '}
            <div className="pressCenter-details-item">
              {/* <div className="pressCenter-details-item-imgbox">
              <div className="pressCenter-details-item-imgbox-new">NEW</div>
            </div> */}
              <div className="pressCenter-details-item-title">喜讯！锐控高端光电编码器芯片成功实现量产</div>
              <div className="pressCenter-details-item-time">2023-03-18</div>
              <div className="pressCenter-details-item-text">光电传感器在生活中随处可见，然而其核心部分光电芯片一直是我国被卡脖子的“痛点”高科技产业。光电编码器芯片就是其中之一。在各类电机控制系统中，光电编码器对控制系统的性能起决定性作用。编码器将信号或数据进行编制，转换为可用于通讯、传输和存储的信号形式，对电机的定位精度、速度稳定性、功率损耗和安全性都有重要影响。如今，传周半导体打破高端光电编码器芯片多年的外国垄断局面，成功实现量产。</div>
              <div className="pressCenter-details-item-button">
                查看详情
                <ArrowRightOutlined style={{ fontSize: '.6rem', marginLeft: '.285714rem ' }} />
              </div>
            </div>
          </Link>
        </div>
        <Footer></Footer>
      </div>
    )
  }
}

export default index
